export const STATE_VERSION: string = '1.0';

export const FRAGNET_SEARCH_ROLE = 'fragnet-search';

export const queryParamsRanges: { [key: string]: [number, number] } = {
  hac: [0, Infinity],
  rac: [0, Infinity],
  hops: [1, 2],
  groupLimit: [1, Infinity],
};

export const floatNumOfBins = 10;
export const floatNumberOfSteps = 100;

// Enums
export enum ApplicationRoutes {
  Base = '/',
  Query = '/query',
  Results = '/results',
  Carts = '/carts',
  Docs = '/docs',
}

export enum DocsRoutes {
  About = ApplicationRoutes.Docs + '/about',
  WhatsNovel = ApplicationRoutes.Docs + '/whatsNovel',
  UserDocs = ApplicationRoutes.Docs + '/userDocs',
  FragnetGeneration = ApplicationRoutes.Docs + '/fragnetGeneration',
}
